<template>
  <div class="home">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>在线订票</el-breadcrumb-item>
        <el-breadcrumb-item>填写信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="public-w order-confirm">
      <div class="order-confirm-text">
        <div class="title display-flex">
          <div class="date">入园时间 {{ orderDate }}</div>
          <div class="num">
            数量<span v-if="orderDetailInfo.users_info">{{
              orderDetailInfo.users_info.length
            }}</span>
          </div>
        </div>
        <div class="details display-flex">
          <div class="time">
            下单时间：{{ orderDetailInfo.create_time }}<br />
            订单编号: {{ orderDetailInfo.order_sn }}<br />
            <i class="el-icon-success"></i><span>已提交订单</span>
          </div>
          <div class="total">
            ￥<span>{{ orderDetailInfo.goods_amount }}</span>
          </div>
        </div>
      </div>
      <div class="user-list">
        <div
          class="user-item display-flex"
          v-for="(userInfo, index) in newUserListArray"
          :key="index"
        >
          <div class="user">
            <div class="user-info">
              <span class="name">{{ userInfo.customer_name }}</span>
              <el-tag type="success" effect="plain">{{
                userInfo.customer_type
              }}</el-tag>
            </div>
            <div class="id">
              {{ IDTypeName(userInfo.id_type) }}：{{ userInfo.id_number }}
            </div>
          </div>
          <div
            class="ticket"
            v-for="(ticketInfo, index) in userInfo.tickets"
            :key="index"
          >
            <div v-if="userInfo.ticket_coupon == 0">
              {{ ticketInfo.config_name }}<br />
              <span v-if="ticketInfo.is_show_price"
                >¥{{ ticketInfo.real_price }}</span
              >
            </div>
          </div>
          <div class="ticket" v-if="userInfo.ticket_coupon == 1">
            <div>
              {{ userInfo.tickets[0].config_name }}
              <span v-if="userInfo.tickets[0].is_show_price"
                >¥{{ userInfo.tickets[0].real_price }}</span
              >
            </div>
            {{ getTicketGroupName(userInfo.real_ticket_configs) }}<br />{{
              getTicketGroupPrice(userInfo.real_ticket_configs)
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="public-w submit-orders display-flex">
      <div class="fl"></div>
      <div class="fr display-flex">
        <div class="total">
          待支付:<span>¥{{ orderDetailInfo.goods_amount }}</span>
        </div>
        <div class="submit">
          <el-button
            type="primary"
            size="medium"
            round
            class="btn"
            @click="payQrCodeFn(orderDetailInfo.goods_amount)"
          >
            立即支付
          </el-button>
        </div>
      </div>
    </div>
    <new-pay-pouup
      :payDialogShow="payQrCode"
      :orderId="orderDetailInfo.order_sn"
      :orderAmount="orderDetailInfo.goods_amount"
      v-on:payPrenterShow="payPrenterShow"
    >
    </new-pay-pouup>
  </div>
</template>
<script>
import { isArray } from '../../setup/common';
import order from '../../api/order';
import constValuesConfig from '../../setup/constantConfig';
/*import PayPouup from '../../components/PayPouup';*/
import NewPayPouup from '../../components/NewPayPouup';
import routerTo from '@/router/routerTo';
export default {
  components: {
    /* PayPouup,*/
    NewPayPouup,
  },
  data() {
    return {
      payQrCode: false, //支付二维码弹框
      orderId: '',
      orderDetailInfo: {},
      usersInfo: [],
      is_union: 0,
      newUserListArray: [],
      certificateTypeList: constValuesConfig.ID,
      orderDate: '',
    };
  },
  mounted() {},
  created() {
    let query = this.$route.query;
    console.log('得到的id', query.orderId);
    this.orderId = query.orderId;
    this.orderDate = query.orderDate;
    this.fetchOrderInfo();
  },
  methods: {
    // 优惠条件弹框
    payQrCodeFn(amount) {
      if (parseFloat(amount) == 0) {
        this.payQrCode = false;
        this.payOrderZero();
      } else {
        this.payQrCode = true;
      }
    },
    async payOrderZero() {
      let that = this;
      const payOrderZeroGet = await order.payOrderZero({
        product_code: process.env.VUE_APP_TICKET_PRODUCT_CODE, //TODO
        order_code: this.orderId,
        pay_channel: 'PO_CASH',
        /*channel_id: '10009'*/
      });
      this.payPrenterShow();
    },
    async fetchOrderInfo() {
      const orderDetailGet = await order.orderDetail({
        order_id: this.orderId,
      });
      this.orderDetailInfo = orderDetailGet;
      console.log('ahhahhah', JSON.stringify(this.orderDetailInfo));
      this.is_union = orderDetailGet.is_union;
      this.usersInfo = orderDetailGet.users_info;
      this.userListSwitch();
    },
    payPrenterShow() {
      this.payQrCode = false;
      this.$router.push({ path: '/account/ticket-order' });
    },
    IDTypeName(idType) {
      let idName = '';
      this.certificateTypeList.forEach((item) => {
        if (item.value == idType) {
          idName = item.name;
        }
      });
      return idName;
    },
    userListSwitch: function() {
      let arr1 = [];
      let obj = {};
      console.log('000000000000');
      console.log(this.usersInfo);
      console.log(this.usersInfo.length);
      let len = this.usersInfo.length;
      // 联票处理
      if (this.isGroup) {
        for (let i = 0; i < len; i++) {
          let union_code = this.usersInfo[i].union_info.union_code;
          if (!obj[union_code]) {
            let objItem = {
              customer_name: this.usersInfo[i].customer_name,
              customer_type: this.usersInfo[i].customer_type,
              id_type: this.usersInfo[i].id_type,
              id_number: this.usersInfo[i].id_number,
              user_channel: this.usersInfo[i].user_channel,
              union_code: union_code,
              real_price: this.usersInfo[i].union_info.real_price,
              config_name: this.usersInfo[i].union_info.config_name,
              tickets: [this.usersInfo[i]],
            };
            arr1.push(objItem);
            obj[union_code] = 1;
          } else {
            console.log(arr1);
            for (let s = 0, lens = arr1.length; s < lens; s++) {
              if (arr1[s].union_code === union_code) {
                arr1[s].tickets.push(this.usersInfo[i]);
              }
            }
          }
        }
        this.newUserListArray = arr1;
      } else {
        this.newUserListArray = this.usersInfo;
        console.log('222222', JSON.stringify(this.newUserListArray));
      }
    },
    //获取门票名称组合
    getTicketGroupName(valItem) {
      if (!Array.isArray(valItem)) {
        return '';
      }
      let ticket_configs = [];
      if (this.is_union) {
        for (let i = 0; i < valItem.length; i++) {
          for (let s = 0; s < valItem[i].tickets.length; s++) {
            ticket_configs.push(valItem[i].tickets[s].config_name);
          }
        }
        if (ticket_configs.length > 0) {
          return '含' + ticket_configs.join(' + ');
        }
      } else {
        for (let i = 0; i < valItem.length; i++) {
          ticket_configs.push(valItem[i].config_name);
        }
        if (ticket_configs.length > 0) {
          return '含' + ticket_configs.join(' + ');
        }
      }
      return '';
    },
    //获取门票价格组合
    getTicketGroupPrice: function(valItem) {
      if (!Array.isArray(valItem)) {
        return '';
      }
      let ticket_configs = [];
      if (this.is_union) {
        for (let i = 0; i < valItem.length; i++) {
          for (let s = 0; s < valItem[i].tickets.length; s++) {
            if (valItem[i].tickets[s].is_show_price) {
              ticket_configs.push(valItem[i].tickets[s].real_price);
            }
          }
        }
        if (ticket_configs.length > 0) {
          return '￥' + '(' + ticket_configs.join(' + ') + ')';
        }
      } else {
        for (let i = 0; i < valItem.length; i++) {
          if (valItem[i].is_show_price) {
            ticket_configs.push(valItem[i].real_price);
          }
        }
        if (ticket_configs.length > 0) {
          return '￥' + '(' + ticket_configs.join(' + ') + ')';
        }
      }
      return '';
    },
  },
};
</script>
<style scoped lang="less">
.order-confirm {
  margin-top: 24px;
  margin-bottom: 16px;
  .order-confirm-text {
    padding: 24px;
    border-bottom: 1px solid #eee;
    .title {
      margin-bottom: 8px;
      line-height: 24px;
      .date {
        color: #191b26;
        font-weight: 500;
        font-size: 20px;
      }
      .num {
        color: #515457;
        font-size: 14px;
        span {
          margin-left: 8px;
          color: #191b26;
          font-weight: bold;
          font-size: 24px;
          vertical-align: middle;
        }
      }
    }
    .details {
      .time {
        color: #515457;
        font-size: 14px;
        line-height: 32px;
        text-align: left;
        i {
          margin-right: 8px;
          color: #31a775;
          font-size: 20px;
          vertical-align: middle;
        }
        span {
          color: #31a775;
          font-weight: 500;
          font-size: 14px;
        }
      }
      .total {
        padding-top: 30px;
        color: #f15b49;
        font-size: 16px;
        span {
          font-weight: 500;
          font-size: 24px;
        }
      }
    }
  }
}
.user-list {
  padding: 0 24px 24px;
  .user-item {
    padding: 24px 0;
    border-bottom: 1px solid #eee;
    .user {
      text-align: left;
      .user-info {
        margin-bottom: 16px;
        .name {
          margin-right: 16px;
          color: #191b26;
          font-weight: 500;
          font-size: 20px;
        }
        /deep/.el-tag {
          border-color: #31a775;
          border-radius: 16px;
          color: #31a775;
          font-size: 16px;
        }
      }
      .id {
        color: #515457;
        font-size: 16px;
      }
    }
    .ticket {
      min-width: 180px;
      padding-top: 8px;
      color: #191b26;
      font-size: 16px;
      line-height: 26px;
      text-align: center;
    }
  }
}
</style>
